import { render, staticRenderFns } from "./122.vue?vue&type=template&id=0a3a0948&scoped=true&"
import script from "./122.vue?vue&type=script&lang=js&"
export * from "./122.vue?vue&type=script&lang=js&"
import style0 from "./122.vue?vue&type=style&index=0&id=0a3a0948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a0948",
  null
  
)

export default component.exports